'use client';

import type React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import LoadingSpinner from '@/components/LoadingSpinner';
import type { AIChat } from '@/types/chat';

interface DeleteChatDialogProps {
  chat: AIChat | null;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteChatDialog: React.FC<DeleteChatDialogProps> = ({ chat, isDeleting, onClose, onConfirm }) => {
  return (
    <Dialog open={!!chat} onOpenChange={(open) => !open && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Delete AI Chat</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete this chat{chat?.summary ? ` "${chat.summary}"` : ''}? This action cannot be
            undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button variant="destructive" onClick={onConfirm} disabled={isDeleting}>
            {isDeleting ? (
              <>
                <div className="h-4 w-4 mr-2">
                  <LoadingSpinner />
                </div>
                Deleting...
              </>
            ) : (
              'Delete'
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteChatDialog;
